import { Resource } from '@ngxp/rest';
import { RegisterName } from '@schir-int-client/register-shared';
import { PagedListResource } from '@schir-int-client/ngrx-helpers';
import { KontaktListLinkRel } from './adressverwaltung.linkrel';

export interface Kontakt {
	juristischePerson: boolean;
	anrede: KontaktAnrede;
	firmenName: string;
	firmenName1: string;
	firmenName2: string;
	titel: string;
	vorname: string;
	name: string;
	geburtsname: string;
	namenszusatz: string;
	sitz: string;
	zustaendigesAmtsgericht: string;
	handelsregisterNummer: string;
	geburtsDatum: Date;
	strasse: string;
	hausnummer: string;
	plz: string;
	stadt: string;
	land: string;
	postfach: string;
	adresszusatz: string;
	egvpAdresse: string;
	email: string;
	telefon: string;
	telefon2: string;
	telefon3: string;
	fax: string;
	deMail: string;
	notiz: string;
	title: string;
	behoerde: boolean;
	active: boolean;
	kontaktId?: string;
	autoKontaktRegister: Partial<Record<KontaktKategorie, RegisterName[]>>;
}

export interface KontaktResource extends Kontakt, Resource {}

export interface VerfahrenKontakt {
	verfahrenId: number;
	kontaktId: number;
	kategorien: KontaktKategorie[];
	aktenzeichen?: string;
	notiz?: string;
}

export interface VerfahrenKontaktResource extends VerfahrenKontakt, Resource {}

export interface KontaktInVerfahren extends Resource {
	kontakt: KontaktResource;
	inVerfahren: VerfahrenKontaktResource;
}

export interface KontaktInVerfahrenListResource extends Resource {
	_embedded?: Resource['_embedded'] & {
		kontaktInVerfahrenResList: KontaktInVerfahren[];
	};
}

export function generateSearchString(kontakt: Kontakt): string {
	const elements = kontakt.juristischePerson
		? [kontakt.firmenName, kontakt.firmenName1, kontakt.firmenName2]
		: [kontakt.vorname, kontakt.name];
	return elements.filter(v => v && v.trim() !== '').join(' ');
}

export interface SearchInputWithModes {
	searchString: string;
	searchModes: KontaktSearchMode[];
}

export interface KontaktWithEditMode {
	kontakt: KontaktResource;
	editMode: boolean;
}

export enum KontaktSearchMode {
	BEHOERDEN = 'behoerden',
	JURISTISCH = 'juristisch',
	NATUERLICH = 'natuerlich',
	INAKTIV = 'inaktiv',
	AKTIV = 'aktiv',
}

export enum KontaktKategorie {
	EIGENTUEMER_NEU = 'EIGENTUEMER_NEU',
	EIGENTUEMER_ALT = 'EIGENTUEMER_ALT',
	EINGETRAGENER_EIGENTUEMER = 'EINGETRAGENER_EIGENTUEMER',
	NOTAR = 'NOTAR',
	GLAEUBIGER_NEU = 'GLAEUBIGER_NEU',
	GLAEUBIGER_ALT = 'GLAEUBIGER_ALT',
	VERTRETER = 'VERTRETER',
	RECHTSANWALT = 'RECHTSANWALT',
	PHG = 'PHG',
	GESELLSCHAFTER = 'GESELLSCHAFTER',
	BEHOERDEN = 'BEHOERDEN',
	SONSTIGE = 'SONSTIGE',
}

export const kontaktKategorien = [
	KontaktKategorie.EIGENTUEMER_NEU,
	KontaktKategorie.EIGENTUEMER_ALT,
	KontaktKategorie.EINGETRAGENER_EIGENTUEMER,
	KontaktKategorie.BEHOERDEN,
	KontaktKategorie.VERTRETER,
	KontaktKategorie.GLAEUBIGER_NEU,
	KontaktKategorie.GLAEUBIGER_ALT,
	KontaktKategorie.NOTAR,
	KontaktKategorie.RECHTSANWALT,
	KontaktKategorie.PHG,
	KontaktKategorie.GESELLSCHAFTER,
	KontaktKategorie.SONSTIGE,
];

export const kontaktKategorienSortingForKontaktlist = [
	KontaktKategorie.EIGENTUEMER_NEU,
	KontaktKategorie.EIGENTUEMER_ALT,
	KontaktKategorie.EINGETRAGENER_EIGENTUEMER,
	KontaktKategorie.VERTRETER,
	KontaktKategorie.GLAEUBIGER_NEU,
	KontaktKategorie.GLAEUBIGER_ALT,
	KontaktKategorie.RECHTSANWALT,
	KontaktKategorie.NOTAR,
	KontaktKategorie.BEHOERDEN,
	KontaktKategorie.PHG,
	KontaktKategorie.GESELLSCHAFTER,
	KontaktKategorie.SONSTIGE,
];

export enum KontaktAnrede {
	FRAU = 'FRAU',
	HERR = 'HERR',
	GUTEN_TAG = 'GUTEN_TAG',
}

export enum KontaktOption {
	DARSTELLUNG = 'DARSTELLUNG',
}

export interface KontaktListResource extends PagedListResource<KontaktResource, KontaktListLinkRel.KONTAKT_LIST> {}
